module.exports = __webpack_public_path__ + "img/image4.7006f39c.jpg";